import React from "react";

const AuthModalClose = ({ onClose }) => (
  <button
    type="button"
    onClick={onClose}
    aria-label="Close"
    className="absolute right-3 top-3 z-20 flex h-11 w-11 items-center justify-center rounded-full border border-white/10 bg-slate-900/60 text-slate-300 shadow-lg backdrop-blur-sm transition-all duration-300 hover:border-amber-400/30 hover:bg-slate-800/80 hover:text-white sm:right-4 sm:top-4"
  >
    <svg
      className="h-4 w-4"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={1.5}
      aria-hidden="true"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  </button>
);

export default AuthModalClose;
